module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('newsletter-form', {
    staticClass: "newsletter--panel",
    attrs: {
      "content": _vm.content
    }
  }, [_c('p', {
    staticClass: "newsletter__message"
  }, [_vm._v(_vm._s(_vm.message))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "background__banner home__banner"
  }, [_vm._v("Info-"), _c('br'), _vm._v("lettre")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b25725c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/generic/NewsletterPanel.vue
// module id = 651
// module chunks = 1